<div class="flex items-center justify-between banner">
  <div class="flex items-center logo-mobile">
    <div class="flex items-center logo-responsive">
      <img class="company-logo" src="assets/images/logos/logo-evn2.png" alt="logo" (click)="goHome()" />
    </div>
    <div class="flex title-header ml-5">Phần mềm quản trị tập trung công tác kế hoạch</div>
  </div>
  <div class="flex items-center header-icons">
    <div class="noti-menu-wrapper" (click)="toggleNotiMenu($event)">
      <i class="pi pi-bell noti-belt">
        <span class="noti-unread" *ngIf="unreadNotificationCount > 0">{{unreadNotificationCount >= 99 ? '99+' :
          unreadNotificationCount}}</span>
      </i>
      <div class="noti-menu" *ngIf="showNotiMenu">
        <ul *ngIf="notifications.length > 0" class="max-h-30rem overflow-y-auto py-0">
          <li (click)="doReadNotification(noti.id)" class="noti-item" *ngFor="let noti of notifications">
            <div class="noti-text">
              <a [pTooltip]="noti.description" tooltipPosition="left"
                class="noti-label text-overflow-ellipsis w-15rem white-space-nowrap overflow-hidden"
                [href]="noti.linkPath">{{noti.description}}</a>
              <div *ngIf="!noti.read" class="noti-dot"></div>
            </div>
            <p class="mt-2 mb-0 text-sm noti-date">{{noti.createDate}}</p>
          </li>
        </ul>

        <div *ngIf="notifications.length == 0" class="noti-empty">
          Không có thông báo nào
        </div>
      </div>
    </div>

    <div class="user-menu-wrapper" (click)="toggleUserMenu($event)">
      <i class="pi pi-user"></i>
      <span class="username">
        {{ displayUserName }}
      </span>

      <div class="user-menu" *ngIf="showUserMenu">
        <ul>
          <li (click)="viewProfile()">
            <i class="pi pi-address-book"></i>
            <span>Thông tin cá nhân</span>
          </li>
          <li (click)="changePassword()">
            <i class="pi pi-lock"></i>
            <span>Đổi mật khẩu</span>
          </li>
          <li (click)="settings()">
            <i class="pi pi-cog"></i>
            <span>Cài đặt</span>
          </li>
          <li class="divider"></li>
          <li (click)="logout()">
            <i class="pi pi-sign-out"></i>
            <span>Đăng xuất</span>
          </li>
        </ul>
      </div>
    </div>

  </div>
</div>

<div class="wrapper-menu hidden lg:block">
  <div class="menu">
    <div class="flex menu-under">
      <div class="menu-wrapper relative" *ngFor="let item of renderMenuItems; trackBy: trackById"
        (mouseenter)="showSubMenu(item)" (mouseleave)="hideSubMenu(item)">
        <a *ngIf="item.subMenu?.length; else noSubMenu" class="menu-item flex items-center cursor-pointer"
          [class.active]="isMenuActive(item)"
          [routerLink]="shouldNavigateOnClick(item) ? getMenuRouterLink(null, item) : null"
          [queryParams]="shouldNavigateOnClick(item) ? item.queryParams : null"
          (click)="shouldNavigateOnClick(item) ? null : $event.preventDefault()">
          <i class="pi {{ item.icon }} icon-menu"></i>
          {{ item.name }}
          <i *ngIf="item.subMenu?.length" class="pi pi-angle-up ml-2 transition-transform duration-300"
            [style.transform]="
              isSubMenuOpen(item) ? 'rotate(180deg)' : 'rotate(0deg)'
            "></i>
        </a>
 
        <ng-template #noSubMenu>
          <a class="menu-item flex items-center" [routerLink]="getMenuRouterLink(null, item)" [queryParams]="item.queryParams"
            [class.active]="isMenuActive(item)">
            <i class="pi {{ item.icon }} icon-menu"></i>
            {{ item.name }}
          </a>
        </ng-template>
 
        <!-- Standard Dropdown for other menus -->
        <div *ngIf="item.subMenu?.length" class="sub-menu-dropdown"
          [ngClass]="{ 'show-sub-menu': isSubMenuOpen(item) }">
          <div class="level-2-wrapper relative" *ngFor="let subItem of item.subMenu"
            (mouseenter)="showChildMenu(subItem)" (mouseleave)="hideChildMenu(subItem)">
            <a *ngIf="subItem.subMenu?.length; else subNoSub" class="sub-menu-item flex justify-between items-center cursor-pointer"
              [class.active]="isMenuActive(subItem)"
              (click)="$event.preventDefault()">
              {{ subItem.name }}
              <i class="pi pi-angle-right ml-2"></i>
            </a>
            <ng-template #subNoSub>
              <a class="sub-menu-item flex justify-between items-center" [routerLink]="getMenuRouterLink(item, subItem)"
                [queryParams]="subItem.queryParams"
                [class.active]="isMenuActive(subItem)">
                {{ subItem.name }}
              </a>
            </ng-template>
 
            <div *ngIf="subItem.subMenu?.length" class="level-3-menu"
              [ngClass]="{ 'show-panel': activeChildMenu === subItem }">
              <ng-container *ngFor="let child of subItem.subMenu">
                <a *ngIf="child.subMenu?.length; else childNoSub" class="sub-menu-item-3 cursor-pointer"
                  [class.active]="isMenuActive(child)"
                  (click)="$event.preventDefault()">
                  {{ child.name }}
                </a>
                <ng-template #childNoSub>
                  <a class="sub-menu-item-3"
                    [routerLink]="getMenuRouterLink(subItem, child)" [queryParams]="child.queryParams"
                    [class.active]="isMenuActive(child)">
                    {{ child.name }}
                  </a>
                </ng-template>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
